import { Component, Inject, ChangeDetectorRef, ViewEncapsulation, AfterViewChecked, ComponentFactoryResolver, ComponentRef, ElementRef, OnDestroy } from '@angular/core';
import { TrackObject } from '../asp/TrackObject';
import * as projEnums from '../common/projEnums';
import * as units from '@core_n/common/units';
import * as aro from '@core_n/aro/aro';
import * as enums from '@core_n/common/enums';
import { AroService } from '@core_n/aro/aro.service';
import { AroTrackCoreComponent } from '@core_n/aro/aro-track-core.component';
import { AroTrackTabGenComponent } from './aro-track-tab-gen.component';
import { AroTrackTabMnvrComponent } from './aro-track-tab-mnvr.component';
import { AroTrackTabClassificationComponent } from './aro-track-tab-classification.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as utils from '@core_n/common/utils';

@Component({
  templateUrl: '../../core/app/aro/aro-track-core.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss']
})

export class AroTrackComponent extends AroTrackCoreComponent implements AfterViewChecked {

  constructor(public dialogRef: MatDialogRef<AroTrackComponent>,
    private userActionSrv: UserActionService,
    elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
    aroService: AroService,
    cdref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver) {
      
    super(aroService, cdref, elementRef, dialogRef);

    this.tab2Label = 'Classiff';
    // this.showNationality = true;
    // this.majorEditable = true;
    // this.minorEditable = true;
    // this.identityEditable = true;
    // this.tab3Label = 'Classiff';
    // this.tab4Label = 'Maneuver';
  }

  ngAfterViewChecked(): void {
    this.cdref.detectChanges();
  }

  protected getTabComponentFactory(tabIndex: number) {
    if (tabIndex == 2)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabGenComponent);
    if (tabIndex == 3)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabClassificationComponent);
    if (tabIndex == 4)
      return this.componentFactoryResolver.resolveComponentFactory(AroTrackTabMnvrComponent);
    else
      return null;
  }

  protected refresh(force: boolean = false): void {
    super.refresh(force);
    if ((this.shown || force) && this.track != null) {
      let track = this.track as TrackObject;
      // this.identityStr = enums.HostilityTitle(this.track.hostility).toUpperCase();

      if (this.showMissileData()) {
        this.missileStage = typeof track.missileBurnoutStatus == 'undefined' ? aro.NO_VALUE : projEnums.burnoutStatusTitle(track.missileBurnoutStatus);
        
        this.missileAccelerationUnits = units.accelerationUnits();
        if (typeof track.accelerationX == 'undefined' ||
          typeof track.accelerationY == 'undefined' ||
          typeof track.accelerationZ == 'undefined')
          this.missileAcceleration = aro.NO_VALUE;
        else
          this.missileAcceleration =
            `${units.accelerationValue(track.accelerationX)} / ${units.accelerationValue(track.accelerationY)} / ${units.accelerationValue(track.accelerationZ)}`;
        
        this.missileSpinRateUnits = 'Hz';
        this.missileSpinRate = typeof track.spinRate == 'undefined' ? aro.NO_VALUE : track.spinRate.toFixed(1);
      }

      if (this.tab2ComponentRef) {
        (this.tab2ComponentRef as ComponentRef<AroTrackTabGenComponent>).instance.refresh(track);
      }
      if (this.tab3ComponentRef) {
        (this.tab3ComponentRef as ComponentRef<AroTrackTabClassificationComponent>).instance.refresh(track);
      }
      if (this.tab4ComponentRef) {
        (this.tab4ComponentRef as ComponentRef<AroTrackTabMnvrComponent>).instance.refresh(track);
      }
      this.cdref.detectChanges();
    }
  }

  showMissileData(): boolean {
    // return this.isMissile || !this.isAbt;
    return false;
  }

  showFlightProgress(): boolean {
    return false;
  }

  setTrack(track: TrackObject) {
    this.track = track;
    this.shown = true;
    this.refresh(true);
  }

  static createDialogConfig(track: TrackObject) {
    let dialogConfig = utils.createDialogConfig(false);
    dialogConfig.data = { track: track };
    return dialogConfig;
  }
}
